import { Component, OnInit, Optional, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource, MatSort, MatPaginator } from '@angular/material';
import { CommonService } from 'src/app/core/service/common-service/common.service';
import { DatePipe } from "@angular/common";
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-customer360',
  templateUrl: './customer360-dialog.component.html',
  styleUrls: ['./customer360-dialog.component.scss']
})

export class Customer360DialogComponent implements OnInit {

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild('CallLogsPaginator', { static: true }) callLogsPaginator: MatPaginator;
  @ViewChild('CallLogsSort', { static: true }) callLogsSort: MatSort;
  @ViewChild('RemarksPaginator', { static: true }) remarksPaginator: MatPaginator;
  @ViewChild('RemarksSort', { static: true }) remarksSort: MatSort
  @ViewChild('ServiceHistoryPaginator', { static: true }) serviceHistoryPaginator: MatPaginator;
  @ViewChild('ServiceHistorySort', { static: true }) serviceHistorySort: MatSort;
  @ViewChild('CallLogsPaginator1', { static: true }) prsCallLogsPaginator: MatPaginator;
  @ViewChild('CallLogsSort', { static: true }) prsCallLogsSort: MatSort;

  cus360: any;
  custNotification: string;
  calltype: string;
  vehicleDetails: any = {};
  lastServiceDetails: any = {};
  serviceDetails: any = {};
  customerID: string;
  spinner: boolean;
  vinNoList: string[] = [];
  vehicleInfoList: any[] = [];
  vehicleTypeCallInfo: any;
  vehicleServiceAndStausInfo: any;
  contactNumbers: any[] = [];
  selectedVehicle: string;
  contactInfoOwner: any[] = [];
  contactInfoFleet: any[] = [];
  contactInfoDriver: any[] = [];
  dataSource1: any = [];
  rows: any = [];
  HideServiceHistory: boolean = true;
  userId: string;
  srmCallLists: any;
  prsCallLists: any;
  recentNumber: string;
  callCount: number = 0;
  prsCallCount: number = 0;
  showRecordingDailog: boolean = false;
  showPlayBtn: boolean = true;
  audioSource: any = {};
  faultDetails: any = [];
  remarksDetails: any;
  remarksCount: number = 0;
  historyDetails: any;
  historyCount: number = 0;
  rrDetails: any = [];
  rrLength: number;
  vin: string;
  roleId: string;

  //service history table columns
  displayedColumns: string[] = [
    "jcNo",
    "servNo",
    "dealerLoc",
    "jbcardDate",
    "mileage",
    "failureDate",
    "billDate",
    "insdate",
    "mechanic",
    "serviceAdv",
    "serviceAdvNo"
  ];

  //call log table columns
  displayedCallColumns: string[] = [
    "number",
    "callDate",
    "startTime",
    "duration",
    "recording"
  ];

  //call log table columns
  displayedRemarksColumns: string[] = [
    "remark",
    "remarkDate",
    "remarkTime"
  ];

  displayedFaultColumns: string[] = [
    "faultCaseId",
    "rulesDesc",
    "faultListDate",
    "faultFertCode",
    "faultServiceDueDate",
    "faultBookingDate"
  ];

  constructor(
    private dialogRef: MatDialogRef<Customer360DialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private commonService: CommonService,
    private datePipe: DatePipe,
    private toastr: ToastrService
  ) {
    this.customerID = data.customerCode;
  }

  ngOnInit() {
    this.userId = localStorage.getItem("userId");
    this.vin = localStorage.getItem("selectedVin");
    this.roleId = localStorage.getItem("roleId");
    this.getCustomer360();
    this.getContactdetail();
    this.getSRMCallList();
    this.getPRSCallList();
  }

  /**
  * Name: getCustomer360
  * purpose: To get customer data
  */
  getCustomer360(): void {
    this.spinner = true;
    let customerID = this.customerID;
    this.commonService.getcustomerdata(customerID, this.userId, this.vin).subscribe(res => {
      if (res["responseCode"] == 0) {
        this.cus360 = res["responseData"];
        if (this.cus360["VECHILE_INFO"] && this.cus360["VECHILE_INFO"].length && this.cus360["VECHILE_INFO"][0].vin6Bits) {
          this.selectedVehicle = this.cus360["VECHILE_INFO"][0].vin6Bits
          this.cus360["VECHILE_INFO"].forEach(element => {
            this.vinNoList.push(element.vin6Bits);
            this.vehicleInfoList.push(element);
          });
          this.subTabDefault(this.selectedVehicle);
        } else {
          this.vehicleDetails = {};
        }
        this.spinner = false;
      } else {
        this.toastr.error(res['message'], "Error");
      }
    }, err => {
      this.spinner = false;
      this.toastr.error("Something went wrong, Please try again.", "Error");
      //...
    });
    //populate vin list
  }

  /**
  * Name: getContactdetail
  * purpose: To get customer Contact detail
  */
  getContactdetail(): void {
    this.spinner = true;
    let customerID = this.customerID;
    this.commonService.contactdetail(customerID).subscribe(res => {
      if (res["responseCode"] == 0) {
        this.contactInfoOwner = res["responseData"].filter(contact => contact.flag == "O");
        this.contactInfoFleet = res["responseData"].filter(contact => contact.flag == "F");
        this.contactInfoDriver = res["responseData"].filter(contact => contact.flag == "D");
        this.spinner = false;
      } else {
        this.spinner = false;
      }
    }, err => {
      this.spinner = false;
      this.toastr.error("Something went wrong, Please try again.", "Error");
      //...
    });
    //populate vin list
  }

  /**
 * Name: subTabDefault
 * purpose: To set default tabs
 */
  subTabDefault(selectedVehicle: string): void {
    this.vehicleDetails = this.cus360["VECHILE_INFO"].filter(vehicle => vehicle.vin6Bits == selectedVehicle)[0];

    //change the sale date format
    this.vehicleDetails.saleDate = this.datePipe.transform(
      this.vehicleDetails.saleDate,
      "yyyy-MM-dd"
    );

    //set the vehicle call Info
    if (this.cus360["SERVICE_INFO"] && Object.keys(this.cus360["SERVICE_INFO"]).length && this.cus360["SERVICE_INFO"][selectedVehicle]) {
      this.serviceDetails = this.cus360["SERVICE_INFO"][selectedVehicle];
      this.vehicleServiceAndStausInfo = this.serviceDetails.serviceType + ", " + this.serviceDetails.callStatus;
      this.vehicleTypeCallInfo = this.serviceDetails.callType;
    } else {
      this.serviceDetails = {};
    }

    if (this.cus360["FAULT_SERVICE_INFO"] && Object.keys(this.cus360["FAULT_SERVICE_INFO"]).length && this.cus360["FAULT_SERVICE_INFO"][selectedVehicle]) {
      let faultInfo = this.cus360["FAULT_SERVICE_INFO"][selectedVehicle];
      this.faultDetails = new MatTableDataSource(faultInfo);
    } else {
      this.faultDetails = [];
    }

    if (this.cus360["LAST_SERVICE_INFO"] && Object.keys(this.cus360["LAST_SERVICE_INFO"]).length && this.cus360["LAST_SERVICE_INFO"][selectedVehicle]) {
      this.lastServiceDetails = this.cus360["LAST_SERVICE_INFO"][selectedVehicle];

      this.lastServiceDetails.invoiceDate = this.datePipe.transform(
        this.lastServiceDetails.invoiceDate,
        "yyyy-MM-dd"
      );
    } else {
      this.lastServiceDetails = {};
    }

    if (this.cus360["Remark_Info"] && Object.keys(this.cus360["Remark_Info"]).length && this.cus360["Remark_Info"][selectedVehicle]) {
      let remarks = this.cus360["Remark_Info"][selectedVehicle];
      remarks.forEach(element => {
        let date = element.remarkTime + " GMT+0000";
        let d = new Date(date);
        element.remarkTime = d;
        element.remarkDate = this.datePipe.transform(element.remarkTime, "yyyy-MM-dd");
      });
      this.remarksDetails = new MatTableDataSource(remarks);
      this.sort.direction = '';
      this.remarksDetails.sort = this.remarksSort;
      this.remarksDetails.paginator = this.remarksPaginator;
      this.remarksCount = remarks.length;
    } else {
      this.remarksDetails = [];
    }
  }

  /**
 * Name: getHistory
 * purpose: To get service history
 */
  getHistory(showHistory: boolean): void {
    if (showHistory) {
      this.spinner = true;
      this.commonService.history(this.vehicleDetails.chassisNo).subscribe(
        res => {
          if (res["responseCode"] == 0) {
            this.HideServiceHistory = false;
            this.dataSource1 = res["responseData"];
            this.historyDetails= new MatTableDataSource(this.dataSource1);
            this.sort.direction = '';
            this.historyDetails.sort = this.serviceHistorySort;
            this.historyDetails.paginator = this.serviceHistoryPaginator;
            this.historyCount = this.dataSource1.length;
            this.spinner = false;
          } else {
            this.toastr.info(res["message"]);
            this.spinner = false;
          }
        }, err => {
          this.spinner = false;
          this.toastr.error("Something went wrong, Please try again.", "Error");
        });
    } else {
      this.HideServiceHistory = true;
    }
  }

  /**
  * Name: getCallList
  * purpose: To get customer call data
  */
  getSRMCallList(): void {
    this.spinner = true;
    let user = "";
    if(this.roleId != "15") {
      user = this.userId;
    }
    this.commonService.callDetails(user, this.customerID, 'SRM').subscribe(res => {
      if (res["responseCode"] == 0) {
        this.spinner = false;
       
        this.srmCallLists = new MatTableDataSource(res['responseData']);
        this.recentNumber = (res['responseData'].length && res['responseData'][0].custNo) ? res['responseData'][0].custNo.split('+91')[1] : '';
        this.sort.direction = '';
        this.srmCallLists.sort = this.callLogsSort;
        this.srmCallLists.paginator = this.callLogsPaginator;
        this.callCount = res['responseData'].length;
      } else {
        this.spinner = false;
      }
    }, err => {
      this.spinner = false;
      this.toastr.error("Something went wrong, Please try again.", "Error");
    });
  }

  /**
  * Name: getCallList
  * purpose: To get customer call data
  */
  getPRSCallList(): void {
    this.spinner = true;
    let user = "";
    if(this.roleId != "15") {
      user = this.userId;
    }
    this.commonService.callDetails(user, this.customerID, 'PRS').subscribe(res => {
      if (res["responseCode"] == 0) {
        this.spinner = false;
       
        this.prsCallLists = new MatTableDataSource(res['responseData']);
        this.recentNumber = (res['responseData'].length && res['responseData'][0].custNo) ? res['responseData'][0].custNo.split('+91')[1] : '';
        this.sort.direction = '';
        this.prsCallLists.sort = this.prsCallLogsSort;
        this.prsCallLists.paginator = this.prsCallLogsPaginator;
        this.prsCallCount = res['responseData'].length;
      } else {
        this.spinner = false;
      }
    }, err => {
      this.spinner = false;
      this.toastr.error("Something went wrong, Please try again.", "Error");
    });
  }

  /**
 * Name: pushData
 * purpose: To generate data for table
 */
  pushData(): void {
    this.dataSource1.forEach(element => this.rows.push(element, { detailRow: true, element }));
  }

  close() {
    this.dialogRef.close();
  }

 /**
 * Name: getCallRecording
 * purpose: To get call recording and play
 */
 recording:string = ''
 getCallRecording(bucketName: string, fileName: string, id: string, source: string ,element): void {
  if (element.recordingUrl) {
    this.recording = element.recordingUrl;
  }else{
    this.recording = '';
  }
  this.spinner = true;
  this.onRecordingClose();
  this.commonService.downloadAudio(bucketName, fileName, source).subscribe(res => {
    this.spinner = false;
    var binary = res['body'];
    var blob = new Blob([binary], { type: 'audio/mp4' });
    this.audioSource.id = id;
    this.audioSource.url = URL.createObjectURL(blob);
    if (this.audioSource.url) {
      this.playRecording();
    }
  }, err => {
    this.spinner = false;
    this.toastr.error("Something went wrong, Please try again.", "Error");
  });
}

/**
   * Name: playRecording
   * purpose: To play recoding
   */
  playRecording(): void {
    this.showPlayBtn = false;
    this.showRecordingDailog = true;
  }

  /**
   * Name: onRecordingClose
   * purpose: To close Recording dailog
   */
  onRecordingClose() {
    this.showPlayBtn = true;
    this.showRecordingDailog = false;
  }
}